import React from 'react';
import { extensions, i18next } from '@yola/ws-sdk';
import TextIndentTrigger from '../components/text-indent-trigger';
import constants from '../constants';
import typedElementsMatches from '../helpers/typed-elements-matches';

const {
  common: { SLUG },
  textIndentTriggerIds: { TEXT_INDENT_TRIGGER_ID },
} = constants;
const { controlTypes } = extensions;

const elementMatches = (element) => {
  const { textContainer, textIndentQuerySelector, textIndentRestrictedParentsSelector } =
    extensions.accessors.getExtensionSettings(SLUG);

  const typedElements = typedElementsMatches();

  if (
    !element.matches(textContainer) ||
    (textIndentRestrictedParentsSelector && element.closest(textIndentRestrictedParentsSelector)) ||
    (textIndentQuerySelector && !typedElements.every((el) => el.matches(textIndentQuerySelector)))
  ) {
    return false;
  }

  return Boolean(typedElements.length);
};

const textIndentControl = {
  id: TEXT_INDENT_TRIGGER_ID,
  trigger: <TextIndentTrigger triggerId={TEXT_INDENT_TRIGGER_ID} iconGlyph="indent-increase" />,
  get tooltip() {
    return i18next.t('Text indent');
  },
  priority: 60,
  for: [controlTypes.TEXT, controlTypes.COLLAPSED_TEXT],
  matches: elementMatches,
  highlightElement: false,
};

export default textIndentControl;
